export class AclOperationsList {
    id: number;
    opName: string;
    classid: number;
}
